import React from 'react';
import { useAuthContext } from '../contexts/AuthContext';

/**
 * SuperAdminGuard — blocks non-superadmin access.
 * 
 * Phase 4 upgrade: Role is now read from AuthContext's `claimsRole` which is 
 * sourced from JWT Custom Claims.
 */
interface SuperAdminGuardProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const SuperAdminGuard: React.FC<SuperAdminGuardProps> = ({
    children,
    fallback = null,
}) => {
    const { claimsRole } = useAuthContext();

    if (claimsRole !== 'superadmin') return <>{fallback}</>;

    return <>{children}</>;
};

export default SuperAdminGuard;
